import { TableHeader, TableRecord } from './types'

export function parseHeaders(headers: string): TableHeader[] {
  return JSON.parse(headers)
}

export function parseData(data: string, headers: TableHeader[]): TableRecord[] {
  return JSON.parse(data).map((item: Record<string, any>) => {
    const sanitisedItem: TableRecord = {}

    Object.keys(item).forEach((key: keyof typeof item) => {
      // Only sanitise fields that are ending up in the table.
      if (headers.some(({ field }: { field: string }) => field === key))
        sanitisedItem[key] = item[key].toString().replace('&amp;', '&') 
      else sanitisedItem[key] = item[key]
    })

    return sanitisedItem
  })
}
